import { apiRequest } from "../../utilities/apiHelper";

export async function getScenarioBaselineApi(organizationId, data) {
  const url = `${organizationId}/energy-insight/scenario-baseline`;
  return await apiRequest('POST', url, data, false);
}

export async function generateScenarioOutputApi(organizationId, data) {
  const url = `${organizationId}/energy-insight/scenario-output`;
  return await apiRequest('POST', url, data, false);
}

export async function saveScenarioOutputApi(organizationId, data) {
  const url = `${organizationId}/scenario-output`;
  return await apiRequest('POST', url, data, false);
}

export async function fetchSavedScenariosOutputApi(organizationId) {
  const url = `${organizationId}/scenario-output`;
  return await apiRequest('GET', url, null, false);
}

export async function deleteSavedScenarioOutputApi(organizationId, id) {
  const url = `${organizationId}/scenario-output/${id}`;
  return await apiRequest('DELETE', url, null, false);
}

export async function getSavedScenarioOutputApi(organizationId, id) {
  const url = `${organizationId}/scenario-output/${id}`;
  return await apiRequest('GET', url, null, false);
}

export async function getEnabledEntitiesIdsBySolarApi(organizationId) {
  const url = `${organizationId}/energy-insight/rooftop-solar-entities`;
  return await apiRequest('GET', url, null, true);
}
